import * as React from 'react';
import { useDispatch } from 'react-redux';
import { fetchSavingsGroups } from '~/CzReimbursement/actions';
import { ThunkDispatch } from '~/Store';
import Autocomplete, { Option } from '~/UI/Autocomplete/Autocomplete';

import styles from './styles.less';

const mapOption = (group: string) => ({ id: group, title: group });

export const SavingsGroupsAutocomplete: React.FunctionComponent<
	React.PropsWithChildren<{
		groupId: string;
		selectedPossibleSavings: string[];
		onChange(savings: string[]): void;
	}>
> = ({ groupId, selectedPossibleSavings, onChange }) => {
	const [options, setOptions] = React.useState<Option[]>([]);
	const [value, setValue] = React.useState('');

	const selectedOptions = React.useMemo(() => selectedPossibleSavings.map(mapOption), [selectedPossibleSavings]);
	const filteredOptions = React.useMemo(
		() => options.filter((option) => option.id.toLowerCase().includes(value)),
		[options, value]
	);

	const dispatch = useDispatch<ThunkDispatch<never>>();
	const fetch = React.useCallback(async () => {
		const groups = await dispatch(fetchSavingsGroups(groupId));
		setOptions(groups.items.map(mapOption));

		const groupsSet = new Set(groups.items);
		const newSelected = selectedPossibleSavings.filter((group) => groupsSet.has(group));
		if (newSelected.length !== selectedPossibleSavings.length) {
			onChange(newSelected);
		}
	}, [groupId, dispatch]);

	return (
		<Autocomplete
			multiple
			options={filteredOptions}
			selectedOptions={selectedOptions}
			styles={styles}
			value={value}
			onFetch={fetch}
			onChange={setValue}
			onSelect={(options) => {
				onChange(options.map((option) => option.id));
			}}
		/>
	);
};
